export default __webpack_public_path__ + "static/media/cucumber.c6398e65.svg";